import CircleEmptyPlusIcon from "../images/CircleEmptyPlusIcon.mjs";

/**
 * App icon for generic creation of a new object
 * @see {GlyphIcon}
 * @see {CircleEmptyPlusIcon}
 */
const AppCreateNewIcon = class extends CircleEmptyPlusIcon {}

export default AppCreateNewIcon;
